import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.MobileApps', {
    intro: 'on your phone',
    appStore: 'App Store',
    googlePlay: 'Google Play',
});
